module.exports = __webpack_public_path__ + "img/lg.71e31f75.jpg";